import Info6Content from '../components/info/Info6PageContent';

const Info6Page = () => {
  return <Info6Content />;
};

export default Info6Page;